import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { deleteWorkOrderDriver } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrderDriverMutations";
import { toast } from "sonner";
import {
  ArrowUpTrayIcon,
  PencilIcon,
  StarIcon,
  TrashIcon,
} from "@heroicons/react/20/solid";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { UpdateProDriverDialog } from "@/app/ProDrivers/Drivers/Components/Dialogs/UpdateProDriverDialog";
import { UserIcon } from "@heroicons/react/16/solid";
import { UpdateWorkOrderAssignmentDialog } from "@/app/ProDrivers/WorkOrders/Components/Dialogs/UpdateWorkOrderAssignmentDialog";
import { AssignmentFilesDialog } from "@/app/ProDrivers/WorkOrders/Components/Dialogs/AssignmentFilesDialog";
import { WorkOrderAssignmentFieldsFragment } from "@/gql/graphql";
import { CreateReviewDialog } from "@/lib/Components/Rating/CreateReviewDialog";
import { useTranslations } from "use-intl";

export function useWorkOrderAssignmentActions(): ActionsHook<WorkOrderAssignmentFieldsFragment> {
  const { mutateAsync } = useGqlMutation(deleteWorkOrderDriver);
  const { open: openEditDriver } = useDialog(UpdateProDriverDialog);
  const { open: openAssignmentDialog } = useDialog(
    UpdateWorkOrderAssignmentDialog,
  );
  const { open: openFilesDialog } = useDialog(AssignmentFilesDialog);
  const { open: openRatingDialog } = useDialog(CreateReviewDialog);
  const t = useTranslations("workOrder.assignmentActions");

  return (assignment) => {
    return [
      {
        label: t("actions"),
        items: [
          {
            actions: [
              {
                label: t("editAssignment"),
                Icon: PencilIcon,
                handleAction: () => {
                  openAssignmentDialog({ assignment });
                },
              },
              {
                label: t("ratePerformance"),
                Icon: StarIcon,
                handleAction: () => {
                  openRatingDialog({
                    assignmentId: assignment.id,
                    proDriverId: assignment.pro_driver_id,
                  });
                },
              },
              {
                label: t("uploadFiles"),
                Icon: ArrowUpTrayIcon,
                handleAction: () => {
                  openFilesDialog({ assignmentId: assignment.id });
                },
              },
            ],
          },
          {
            actions: [
              {
                label: t("editDriver"),
                Icon: UserIcon,
                handleAction: () => {
                  openEditDriver({ paidDriverId: assignment.pro_driver_id });
                },
              },
            ],
          },
          {
            actions: [
              {
                label: t("delete"),
                color: "red",
                Icon: TrashIcon,
                handleAction: async () => {
                  await mutateAsync({
                    id: assignment.id,
                  });

                  toast.success(t("driverDeleted"));
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
